import { render, staticRenderFns } from "./WorkUnitSelect.vue?vue&type=template&id=2f50e3e0&"
import script from "./WorkUnitSelect.vue?vue&type=script&lang=js&"
export * from "./WorkUnitSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports